import DateDisplay from 'components/DateDisplay';
import { UserRow } from 'components/tables/data/user/types';

/**
 * Column renderer for the password-valid-until date in the admin users table.
 */
export default function PasswordValidUntilColumn({ data }: { data: UserRow & { passwordValidUntil?: string } }) {
  if (!data.passwordValidUntil) {
    return '';
  }

  return <DateDisplay date={new Date(data.passwordValidUntil)} withTime withRelative />;
}
